import thunk from "redux-thunk";

import { isDevelopment, isShadow } from "./utils/isDevelopment";
import { createReduxStore } from "./utils/store";
import { fetchRegistration } from "./actions/registrationActions";
import { fetchBranding } from "./actions/brandingActions";
import { datadogLogs } from "@datadog/browser-logs";
import renderSelfRegistration from "./SelfRegistration";

export const init = async () => {
  //catch errors and report to Datadog
  if (!isDevelopment) {
    datadogLogs.init({
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
      env: process.env.REACT_APP_DATADOG_ENV,
      site: "datadoghq.com",
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      service: "web-self-registration"
    });
  }

  // Data dog middle ware to report redux errors.
  const datadogMiddleware =
    ({ dispatch, getState }) =>
      next =>
        action => {
          // Pass the action to the next middleware or reducer
          try {
            next(action);
          } catch (error) {
            datadogLogs.logger.error(
              "An error occurred in web-portal(redux)",
              {
                message: error.message,
                stack: error.stack,
                action: action
              },
              error
            );
          }
        };

  const store = createReduxStore({
    isDevelopment: (isDevelopment || isShadow),
    middlewares: [
      datadogMiddleware,
      thunk
    ],
  });

  store.dispatch(fetchBranding());
  store.dispatch(fetchRegistration());

  renderSelfRegistration({
    store,
  });
};
